import { RouteRecordRaw } from "vue-router";
import { RouteName } from "@/apps/merchant3/router/RouteName";
import { navigationGuard } from "@/apps/merchant3/helpers/navigationGuards";
import { CheckoutStep } from "@/apps/merchant3/enums/checkoutStepEnum";
import KycView from "@/apps/merchant3/views/steps/KycView.vue";
import CreditCheckView from "@/apps/merchant3/views/steps/CreditCheckView.vue";
import CustomerDateOfBirthView from "@/apps/merchant3/components/customer-registration/views/CustomerDateOfBirthView.vue";
import CustomerIdNumberView from "@/apps/merchant3/components/customer-registration/views/CustomerIdNumberView.vue";
import CustomerContactInfoView from "@/apps/merchant3/components/customer-registration/views/CustomerContactInfoView.vue";
import OffersView from "@/apps/merchant3/views/OffersView.vue";
import PreparingOffersView from "@/apps/merchant3/views/PreparingOffersView.vue";
import { merchant3TranslationGuard } from "@/router/translationGuards";
import PolicyView from "@/apps/merchant3/views/steps/PolicyView.vue";

const enableRUMMeta = { enableRUM: true };
export const configurableRoutes: Array<RouteRecordRaw> = [
  // New URL structure: /:countryCode/store/step/*
  {
    path: "/:countryCode/store/step/policy",
    name: RouteName.M3ConfigurablePolicy,
    component: PolicyView,
    beforeEnter: [navigationGuard, merchant3TranslationGuard],
    meta: {
      ...enableRUMMeta,
      step: CheckoutStep.POLICY,
    },
  },
  {
    path: "/:countryCode/store/step/kyc",
    name: RouteName.M3ConfigurableKyc,
    component: KycView,
    beforeEnter: [navigationGuard, merchant3TranslationGuard],
    meta: {
      ...enableRUMMeta,
      step: CheckoutStep.KYC,
    },
  },
  {
    path: "/:countryCode/store/step/customer-contact-information",
    name: RouteName.M3ConfigurableCustomerContactInfo,
    component: CustomerContactInfoView,
    beforeEnter: [navigationGuard, merchant3TranslationGuard],
    meta: {
      ...enableRUMMeta,
      step: CheckoutStep.CUSTOMER_CONTACT_INFO,
    },
  },
  {
    path: "/:countryCode/store/step/credit-check",
    name: RouteName.M3ConfigurableCreditCheck,
    component: CreditCheckView,
    beforeEnter: [navigationGuard, merchant3TranslationGuard],
    meta: {
      ...enableRUMMeta,
      step: CheckoutStep.CREDIT_CHECK,
    },
  },
  {
    path: "/merchant3/step/dob-verification",
    name: RouteName.M3ConfigurableDob,
    component: CustomerDateOfBirthView,
    beforeEnter: [navigationGuard],
    meta: {
      ...enableRUMMeta,
      isConfigurable: true,
    },
  },
  {
    path: "/merchant3/step/id-number-dob-verification",
    name: RouteName.M3ConfigurableIdNumberDob,
    component: CustomerIdNumberView,
    beforeEnter: [navigationGuard],
    meta: {
      ...enableRUMMeta,
      isConfigurable: true,
    },
  },
  {
    path: "/merchant3/step/offers",
    name: RouteName.M3ConfigurableOffers,
    component: OffersView,
    beforeEnter: [navigationGuard],
    meta: {
      ...enableRUMMeta,
      step: CheckoutStep.OFFERS,
      isConfigurable: true,
    },
  },
  {
    path: "/merchant3/step/offers-v2",
    name: RouteName.M3ConfigurableOffersV2,
    component: PreparingOffersView,
    beforeEnter: [navigationGuard],
    meta: {
      ...enableRUMMeta,
      step: CheckoutStep.OFFERS,
      isConfigurable: true,
    },
  },
];
